import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import {
  useFetchApi,
  Config,
  Translator,
  useRedirect,
  useQueryParams,
} from "@itarget/shared";
import { toast } from "../../redux";
import DetailMyCourseGrouped from "./views/DetailMyCourseGrouped";
import { parseFloat } from "globalthis/implementation";
import { enumsPoll } from "@itarget/shared/src/enums";

const DetailMyCourseGroupContainer = () => {
  const dispatch = useDispatch();
  const { goTo } = useRedirect();
  const refPlayer = useRef();
  const { id } = useParams();
  const { get } = useQueryParams();
  const defaultModule = get("defaultModule");
  const [showVideo, setShowVideo] = useState(false);
  const [showQuiz, setShowQuiz] = useState(false);
  const [showAnswers, setShowAnswers] = useState(false);
  const [endVideo, setEndVideo] = useState(false);
  const [progress, setProgress] = useState({
    playedSeconds: 0,
    played: 0,
    loadedSeconds: 0,
    loaded: 0,
  });
  const [playing, setPlaying] = useState(false);
  const [totalWatch, setTotalWatch] = useState(0);
  const [percentNextVideo, setPercentNextVideo] = useState(1);
  const [lesson, setLesson] = useState({});
  const [speakers, setSpeakers] = useState("");
  const [polls, setPolls] = useState({});
  const selectedLang = useSelector((state) => state.language.lang);
  const user = useSelector((state) => state.auth.user);
  const settingCommerce = useSelector((state) => state.setting.settingCommerce);
  const centerCostId = useSelector((state) => state.auth.cc);
  const [secondsLeft, setSecondsLeft] = useState();
  const [assistedTimeout, setAssistedTimeout] = useState();
  const [secondsLeftQuiz, setSecondsLeftQuiz] = useState();
  const [quizTimeout, setQuizTimeout] = useState();
  const [intervalId, setIntervalId] = useState();
  const [lastPollsInsideIntervals, setLastPollsInsideIntervals] = useState([]);
  const [finalResultsByScheduleId, setFinalResultsByScheduleId] = useState({});

  const translation = {
    alreadyAnswered: Translator({
      transRef: "translation.Você já respondeu o questionário!",
    }),
  };

  useEffect(() => {
    if (settingCommerce?.meta_proximovideo) {
      setPercentNextVideo(parseFloat(settingCommerce?.meta_proximovideo) / 100);
    }
  }, [settingCommerce]);

  const { fetchData: fetchSendVideo } = useFetchApi(
    Config.baseURL + `api/${selectedLang}/video-frequency`,
    "POST"
  );

  const {
    data: getVideo,
    error: errorGetVideo,
    fetchData: fetchGetVideo,
  } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/video-frequency/${
        lesson && lesson.agenda_atividade_detalhe_id
      }/resume?pessoa_id=${user.data && user.data.id}`
  );

  const {
    data: detailRequest,
    fetchData: fetchDetailRequest,
    isLoading: isLoadingDetailRequest,
  } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/activity-payment/${id}/detailing?centro_custo_id=${centerCostId}${
        user?.data ? "&pessoa_id=" + user.data.id : ""
      }`
  );

  const {
    data: dataDetail,
    error: errorDetail,
    fetchData: fetchDetail,
    isLoading: isLoadingDetail,
  } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/activity-schedule/${id}/detail?pessoa_id=${user?.data?.id}&group_by=${detailRequest?.data?.detailing?.[0]?.commerce_ondemand_exibicao}&centro_custo_id=${centerCostId}`
  );

  const {
    data: videoPolls = { data: [] },
    fetchData: fetchVideoPolls,
    isLoading: isLoadingVideoPolls,
  } = useFetchApi(
    `${Config.baseURLV2}api/classroom/schedule-activity-details/${lesson.agenda_atividade_detalhe_id}/video-polls`
  );

  const {
    data: quizResults,
    fetchData: fetchQuizResults,
    isLoading: isLoadingQuizResults,
  } = useFetchApi(
    `${Config.baseURL}api/${selectedLang}/question/activity-schedule-detail/${
      lesson?.agenda_atividade_detalhe_id
    }?pessoa_id=${user?.data?.id}&centro_custo_id=${
      detailRequest?.data?.detailing?.[0]?.centro_custo_id_out || centerCostId
    }`
  );

  const {
    data: questionResult,
    fetchData: getQuestionResult,
    isLoading: isLoadingQuestionResult,
  } = useFetchApi(
    `${Config.baseURL}api/${selectedLang}/question?centro_custo_id=${
      detailRequest?.data?.detailing?.[0]?.centro_custo_id_out || centerCostId
    }&pessoa_id=${user.data.id}&formulario_pergunta_id=${
      lesson?.formulario_pergunta_id
    }&destino_pergunta=${enumsPoll.DESTINATION_QUESTION.QUESTIONNAIRE}`
  );

  const isVideoInsideVideoPolls = videoPolls?.data
    ? videoPolls?.data.some(
        ({ pollId }) => pollId === polls?.formulario_pergunta_id
      )
    : false;

  const { fetchData: getVideoPolls } = useFetchApi();
  const { fetchData: getQuestionList } = useFetchApi();
  const { fetchData: fetchFinalResult, isLoading: isLoadingFinalResult } =
    useFetchApi();

  const { fetchData: fetchTrack } = useFetchApi(
    Config.baseURL + `api/${selectedLang}/log/track`,
    "POST"
  );

  useEffect(() => {
    fetchDetailRequest();
  }, [id, user?.data?.id]);

  useEffect(() => {
    if (!detailRequest?.data?.detailing?.[0]?.commerce_ondemand_exibicao)
      return;
    fetchDetail();
    return () => {
      resetState();
    };
  }, [id, detailRequest?.data?.detailing]);

  useEffect(() => {
    if (errorGetVideo !== null) {
      dispatch(
        toast.actions.enqueue({
          content: errorGetVideo,
          severity: "error",
        })
      );
    }
  }, [errorGetVideo, dispatch]);

  useEffect(() => {
    if (errorDetail !== null) {
      dispatch(
        toast.actions.enqueue({
          content: errorDetail,
          severity: "error",
        })
      );
    }
  }, [errorDetail, dispatch]);

  useEffect(() => {
    if (showVideo && lesson?.agenda_atividade_detalhe_id) {
      fetchGetVideo();
    }
  }, [showVideo, lesson?.agenda_atividade_detalhe_id]);

  useEffect(() => {
    if (getVideo && getVideo.data.posicao && refPlayer.current) {
      const posicao = getVideo.data.posicao;
      const time = posicao.seconds ? posicao.seconds : posicao.playedSeconds;
      setTotalWatch(posicao.playedSeconds);
      if (posicao.played !== 1 && getVideo.data.tipo !== "F") {
        refPlayer.current.seekTo(posicao.played, "fraction");
        setProgress(posicao);
      }
    }
  }, [getVideo, refPlayer.current]);

  useEffect(() => {
    if (lesson && lesson?.formulario?.length > 0) {
      setPolls(lesson.formulario[0]);
      return;
    }
    setPolls({});
  }, [lesson]);

  useEffect(() => {
    if (lesson?.agenda_atividade_detalhe_id) {
      fetchVideoPolls();
    }
  }, [lesson?.agenda_atividade_detalhe_id]);

  useEffect(() => {
    if (
      showAnswers &&
      videoPolls?.data &&
      lesson?.agenda_atividade_detalhe_id
    ) {
      if (videoPolls?.data.length > 0) {
        fetchQuizResults();
      } else {
        getQuestionResult();
      }
    }
  }, [videoPolls, showAnswers, lesson?.agenda_atividade_detalhe_id]);

  const fetchFinalResults = async (
    activityScheduleDetailId,
    activityScheduleDetailParentId,
    isReload = false
  ) => {
    if (finalResultsByScheduleId[activityScheduleDetailId] && !isReload) return;

    const response = await fetchFinalResult(
      null,
      Config.baseURL +
        `api/${selectedLang}/question/final-result?personId=${user.data.id}${
          activityScheduleDetailId
            ? `&activityScheduleDetailId=${activityScheduleDetailId}`
            : ""
        }${
          activityScheduleDetailParentId
            ? `&activityScheduleDetailParentId=${activityScheduleDetailParentId}`
            : ""
        }`
    );
    return response.data || [];
  };

  const loadFinalResultsOnExpand = async (activityScheduleDetailParentId) => {
    if (isLoadingFinalResult) return;
    if (finalResultsByScheduleId[activityScheduleDetailParentId]) return;

    const results = await fetchFinalResults(
      null,
      activityScheduleDetailParentId
    );
    setFinalResultsByScheduleId((prev) => ({
      ...prev,
      [activityScheduleDetailParentId]: results,
    }));
  };

  const loadFinalResultsOnEachItem = async (activityScheduleDetailId) => {
    if (isLoadingFinalResult) return;
    if (finalResultsByScheduleId[activityScheduleDetailId]) return;

    const results = await fetchFinalResults(activityScheduleDetailId);
    setFinalResultsByScheduleId((prev) => ({
      ...prev,
      [activityScheduleDetailId]: results,
    }));
  };

  const reloadFinalResults = async (
    activityScheduleDetailId = null,
    activityScheduleDetailParentId = null
  ) => {
    const results = await fetchFinalResults(
      activityScheduleDetailId,
      activityScheduleDetailParentId,
      true
    );
    setFinalResultsByScheduleId((prev) => ({
      ...prev,
      [activityScheduleDetailId || activityScheduleDetailParentId]: results,
    }));
  };

  const selectStep = (lesson, speakers, type) => {
    setLesson(lesson);
    setSpeakers(speakers);
    if (["video-poll", "question"].includes(type)) {
      const quiz = lesson.formulario?.[0];
      if (!quiz.pode_responder) {
        dispatch(
          toast.actions.enqueue({
            content: quiz.mensagem_limite_tempo,
            severity: "info",
          })
        );
        return false;
      }
      fetchTrack(
        JSON.stringify({
          trackable_id: quiz.formulario_pergunta_id,
          trackable_type: "formularios_perguntas",
          pessoa_id: user.data.id,
          action: "QUIZ_STARTED",
        })
      );
      setPolls(quiz);
      setShowQuiz(true);
      initializePollTimer(lesson);
      return true;
    }
    if (type === "answers") {
      setShowVideo(false);
      setShowQuiz(false);
      setShowAnswers(true);
      return true;
    }
    if (!lesson.pode_assistir) {
      dispatch(
        toast.actions.enqueue({
          content: lesson.mensagem_limite_tempo,
          severity: "info",
        })
      );
      return false;
    }
    setShowVideo(true);
    return true;
  };

  const resetState = () => {
    refPlayer.current = null;
    setProgress({ playedSeconds: 0, played: 0, loadedSeconds: 0, loaded: 0 });
    setTotalWatch(0);
    setLesson({});
    setEndVideo(false);
    setSecondsLeft();
    setAssistedTimeout();
    setSecondsLeftQuiz();
    setQuizTimeout();
    setIntervalId();
    fetchDetail();
  };

  const sendVideo = (tipo, posicao) => {
    const seconds =
      posicao !== undefined ? posicao.playedSeconds : progress.playedSeconds;

    fetchSendVideo(
      JSON.stringify({
        agenda_atividade_detalhe_id: lesson.agenda_atividade_detalhe_id,
        pessoa_id: user.data.id,
        tipo: tipo,
        posicao: posicao ? posicao : progress,
        replay: totalWatch > seconds || endVideo ? "S" : "N",
      })
    );
  };

  const closeShowVideo = () => {
    refPlayer.current = null;
    setShowVideo(false);
    setLesson({});
    setTotalWatch(0);
    setProgress({ playedSeconds: 0, played: 0, loadedSeconds: 0, loaded: 0 });
    fetchDetail();
  };

  const onPause = (e) => {
    setPlaying(false);
    if (e.percent < 1) {
      sendVideo("P");
    }
  };

  const onPlay = () => {
    sendVideo("I");
    setPlaying(true);
    if (!lesson.data_inicio_video && lesson.disponivel_por > 0) {
      fetchTrack(
        JSON.stringify({
          trackable_id: lesson.agenda_atividade_detalhe_id,
          trackable_type: "agenda_atividades_detalhes",
          pessoa_id: user.data.id,
          action: "VIDEO_STARTED",
        })
      );
    }
    limitTimeVideo();
  };

  const fetchQuestions = async (fetchFunction, id) => {
    const { data } = await fetchFunction(
      null,
      `${Config.baseURL}api/${selectedLang}/question?centro_custo_id=${
        detailRequest?.data?.detailing?.[0]?.centro_custo_id_out || centerCostId
      }&pessoa_id=${
        user.data.id
      }&formulario_pergunta_id=${id}&destino_pergunta=${
        enumsPoll.DESTINATION_QUESTION.QUESTIONNAIRE
      }`
    );
    return data;
  };

  const openQuestionFromCurrentLessonWithQuestionId = async (course) => {
    const treatedLesson = course;
    treatedLesson.formulario = [];

    if (!treatedLesson.formulario_pergunta_id) return false;

    const questionList = await fetchQuestions(
      getQuestionList,
      course.formulario_pergunta_id
    );

    if (questionList) treatedLesson.formulario = questionList;

    return selectStep(treatedLesson, speakers, "question");
  };

  const openPollFromCurrentLessonWithPollId = async (pollId) => {
    const treatedLesson = lesson;
    treatedLesson.formulario = [];

    const [poll] = await fetchQuestions(getVideoPolls, pollId);

    if (poll) treatedLesson.formulario.push(poll);

    return selectStep(lesson, speakers, "video-poll");
  };

  const getCurrentPollId = (playedSeconds) => {
    const lastPollsInsideIntervals = videoPolls?.data?.filter(
      ({ pauseTimeSecond }) => {
        return (
          pauseTimeSecond <= playedSeconds &&
          pauseTimeSecond + 10 >= playedSeconds
        );
      }
    );

    setLastPollsInsideIntervals(lastPollsInsideIntervals);
    return lastPollsInsideIntervals
      ? lastPollsInsideIntervals[lastPollsInsideIntervals.length - 1]
      : {};
  };

  const isCurrentInsidePollInsideIntervalArray = (
    currentPollInsideInterval
  ) => {
    return lastPollsInsideIntervals.some(
      ({ pauseTimeSecond }) =>
        pauseTimeSecond === currentPollInsideInterval.pauseTimeSecond
    );
  };

  const verifyPollInsideVideoWithPlayedSeconds = async (playedSeconds) => {
    if (!playedSeconds) return;
    const currentPollInsideInterval = getCurrentPollId(playedSeconds);
    if (!currentPollInsideInterval) return;
    if (isCurrentInsidePollInsideIntervalArray(currentPollInsideInterval))
      return;
    const canOpenPoll = await openPollFromCurrentLessonWithPollId(
      currentPollInsideInterval.pollId
    );
    if (!canOpenPoll) return;
    document.exitFullscreen();
    setPlaying(false);
  };

  const onProgress = (progressEvent) => {
    verifyPollInsideVideoWithPlayedSeconds(progressEvent.playedSeconds);
    if (totalWatch < progressEvent.playedSeconds) {
      setTotalWatch(progressEvent.playedSeconds);
    }
    setProgress(progressEvent);
    sendVideo(progressEvent.played < 1 ? "P" : "F", progressEvent);
  };

  const onEnded = () => {
    const position = {
      playedSeconds: progress.loadedSeconds,
      played: 1,
      loadedSeconds: progress.loadedSeconds,
      loaded: progress.loaded,
    };
    setTotalWatch(progress.loadedSeconds);
    setPlaying(false);
    sendVideo("F", position);
    setEndVideo(true);
    setProgress({ playedSeconds: 0, played: 0, loadedSeconds: 0, loaded: 0 });
  };

  const closeShowQuiz = () => {
    if (detailRequest?.data?.detailing?.[0]?.commerce_ondemand_exibicao == 1) {
      reloadFinalResults(lesson.agenda_atividade_detalhe_id);
    }
    if (
      detailRequest?.data?.detailing?.[0]?.commerce_ondemand_exibicao == 2 &&
      lesson.agenda_atividade_detalhe_pai_id
    ) {
      reloadFinalResults(null, lesson.agenda_atividade_detalhe_pai_id);
    }
    fetchDetail();
    if (intervalId) {
      clearInterval(intervalId);
    }
    setShowQuiz(false);
  };

  const closeShowAnswers = () => {
    setShowAnswers(false);
  };

  const setOpenPoll = () => {
    if (dataDetail?.data?.perguntas?.respondido) {
      dispatch(
        toast.actions.enqueue({
          content: translation.alreadyAnswered,
          severity: "info",
        })
      );
    } else {
      setPolls(dataDetail.data.perguntas);
      setShowQuiz(true);
    }
  };

  const setOpenCertificate = (url) => {
    window.open(url);
  };

  const limitTimeVideo = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    const newIntervalId = setInterval(() => {
      if (assistedTimeout) {
        setAssistedTimeout((assisted) => {
          assisted -= 1;
          return assisted;
        });
      }
      if (secondsLeft) {
        setSecondsLeft((seconds) => {
          if (seconds < 1) {
            goTo(`my-course/${lesson.agenda_atividade_id}`);
            return;
          }
          seconds -= 1;
          return seconds;
        });
      }
    }, 1000);

    setIntervalId(newIntervalId);
  };

  const limitTimeQuiz = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    const newIntervalId = setInterval(() => {
      if (quizTimeout) {
        setQuizTimeout((quizView) => {
          quizView -= 1;
          return quizView;
        });
      }
      if (secondsLeftQuiz < 1 && videoPolls?.data?.length > 0) {
        closeShowQuiz();
        setPlaying(true);
      }
      if (secondsLeftQuiz < 1 && videoPolls?.data?.length === 0) {
        goTo(`my-course/${lesson.agenda_atividade_id}`);
      }
      if (secondsLeftQuiz) {
        setSecondsLeftQuiz((seconds) => {
          seconds -= 1;
          return seconds;
        });
      }
    }, 1000);

    setIntervalId(newIntervalId);
  };

  const onEndQuizCallback = (quiz) => {
    if (videoPolls?.data?.length > 0) {
      setPlaying(true);
    }
  };

  useEffect(() => {
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const initializePollTimer = (lesson) => {
    if (lesson) {
      if (lesson.disponivel_por) {
        if (lesson.data_inicio_video) {
          const date1 = new Date(
            lesson.data_inicio_video.replace(/\.\d+$/, "").replace(" ", "T")
          );
          const date2 = new Date(lesson.data_hora);
          const differenceInSeconds = Number.parseInt(
            Math.abs((date1.getTime() - date2.getTime()) / 1000)
          );
          setSecondsLeft(lesson.disponivel_por * 60 - differenceInSeconds);
        } else {
          setSecondsLeft(lesson.disponivel_por * 60);
        }
      }

      if (lesson?.formulario?.[0]?.disponivel_por) {
        if (lesson?.formulario?.[0]?.data_inicio_questionario) {
          const date1 = new Date(
            lesson?.formulario?.[0]?.data_inicio_questionario
              .replace(/\.\d+$/, "")
              .replace(" ", "T")
          );
          const date2 = new Date(lesson?.formulario?.[0]?.data_hora);
          const differenceInSeconds = Number.parseInt(
            Math.abs((date1.getTime() - date2.getTime()) / 1000)
          );
          setSecondsLeftQuiz(
            lesson?.formulario?.[0]?.disponivel_por * 60 - differenceInSeconds
          );
        } else {
          setSecondsLeftQuiz(lesson?.formulario?.[0]?.disponivel_por * 60);
        }
      }
    }
  };

  useEffect(() => {
    initializePollTimer(lesson);
  }, [lesson]);

  return (
    <DetailMyCourseGrouped
      isLoading={
        isLoadingDetail || isLoadingVideoPolls || isLoadingDetailRequest
      }
      isLoadingDetail={isLoadingDetail}
      id={id}
      totalWatch={totalWatch}
      playing={playing}
      refPlayer={refPlayer}
      showVideo={showVideo}
      showQuiz={showQuiz}
      showAnswers={showAnswers}
      detail={dataDetail}
      lesson={lesson}
      speakers={speakers}
      polls={polls}
      detailRequest={detailRequest}
      isVideoInsideVideoPolls={isVideoInsideVideoPolls}
      canControlVideoProgressBar={!videoPolls?.data?.length}
      closeShowVideo={closeShowVideo}
      closeShowAnswers={closeShowAnswers}
      selectStep={selectStep}
      onPause={onPause}
      onPlay={onPlay}
      onProgress={onProgress}
      onEnded={onEnded}
      closeShowQuiz={closeShowQuiz}
      setOpenPoll={setOpenPoll}
      setOpenCertificate={setOpenCertificate}
      percentNextVideo={percentNextVideo}
      secondsLeft={secondsLeft}
      secondsLeftQuiz={secondsLeftQuiz}
      limitTimeQuiz={limitTimeQuiz}
      onEndQuizCallback={onEndQuizCallback}
      ondemandFormat={
        detailRequest?.data?.detailing?.[0]?.commerce_ondemand_exibicao
      }
      defaultModule={defaultModule}
      openQuestionFromCurrentLessonWithQuestionId={
        openQuestionFromCurrentLessonWithQuestionId
      }
      quizResults={
        questionResult?.data?.[0]
          ? { data: [{ formulario: questionResult?.data?.[0] }] }
          : quizResults
      }
      isLoadingQuizResults={
        isLoadingQuizResults || isLoadingQuestionResult || isLoadingVideoPolls
      }
      onOpenSubmodule={loadFinalResultsOnExpand}
      finalResultsByScheduleId={finalResultsByScheduleId}
      isLoadingFinalResult={isLoadingFinalResult}
      settingCommerce={settingCommerce}
      loadFinalResultsOnEachItem={loadFinalResultsOnEachItem}
    />
  );
};

export default DetailMyCourseGroupContainer;
